import { useCallback, useRef } from 'react'

import { BottomSheetModal } from '@gorhom/bottom-sheet'

export const useJoinPremiumSheet = () => {
  const joinPremiumSheetRef = useRef<BottomSheetModal>(null)

  const openBottomModal = useCallback(() => {
    joinPremiumSheetRef.current?.present()
  }, [])

  const closeBottomModal = useCallback(() => {
    joinPremiumSheetRef.current?.close()
  }, [joinPremiumSheetRef])

  const handleJoinPremiumSheet = () => openBottomModal()

  return {
    joinPremiumSheetRef,
    closeBottomModal,
    handleJoinPremiumSheet
  }
}
